"use client";

import React, { useContext } from "react";
import { useRouter } from "next/navigation";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Chip } from "@/components/Chip";
import { Banner } from "@/components/Banner";
import { Typography } from "@/components/Typography";
import { featuredAIProps } from "@/data/types/home";
import { AmplitudeContext } from "@/contexts/AmplitudeContext/AmplitudeContext";
import { NextImage } from "../NextImage";
import { paths } from "@/utils/paths";
import "./styles.scss";

export const AIModule = ({ data }: { data: featuredAIProps }) => {
  const {
    backgroundColor: bg,
    chipLabel,
    ctaLabel,
    data_qa,
    imageAlt,
    imageSrc,
    subtitle,
    subtitle2,
    title,
  } = data;
  const router = useRouter();
  const { setSource } = useContext(AmplitudeContext);
  const handleAIStepClick = () => {
    setSource("cta_steps");
    router.push(paths.qrEditor());
  };

  return (
    <Banner
      small
      light
      customBgColor={bg}>
      <div className="ai-module">
        <div className="ai-module__header">
          <div className="ai-module__header__title">
            <div className="ai-module__header__title__text">
              <Chip
                label={chipLabel}
                type="filled"
                color="warning"
                className="ai-module__header__title__text__chip"
              />
              <Typography
                Tag="h2"
                classname="u-text-center u-spacing-0">
                {title}
              </Typography>
            </div>
          </div>
          <div className="ai-module__header__subtitle">
            <Typography
              Tag="p"
              classname="u-text-center">
              {subtitle}
            </Typography>

            {subtitle2 && (
              <Typography
                Tag="p"
                classname="u-text-center">
                {subtitle}
              </Typography>
            )}
          </div>
          <div className="ai-module__header__cta">
            <ButtonLib
              dataQA={data_qa}
              onClick={handleAIStepClick}
              label={ctaLabel}
              variant="secondary"
            />
          </div>
        </div>
        <div className="ai-module__image">
          <NextImage
            src={imageSrc}
            width={499}
            height={385}
            alt={imageAlt}
          />
        </div>
      </div>
    </Banner>
  );
};
